import * as MuiIcons from "@mui/icons-material";
import * as Mui from "@mui/material";
import FormInput from "../../../common/FormInput";
import useOperationTranslation from "../../../../hooks/useOperationTranslation";
import { useContext, useMemo } from "react";
import { AutoCompleteOption } from "../../../common/AutoComplete";
import { useForm } from "react-hook-form";
import { nameof } from "../../../common/ObjectUtils";
import { ContextOperation } from "../../../../context/OperationContext";
import { DamageFormTypes } from "../../../damageFormList/Types";
import { useNavigate, useSearchParams } from "react-router-dom";
import DamagePriceService from "../../service/damagePrice.action";

interface FormInputs {
  formCode: string
}

interface Props {
    isOpen: boolean;
    formCode: string | undefined;
    onClose: () => void;
    forms: string[];
  }
const ChooseForm = (props: Props) => {
  const t = useOperationTranslation();
  const { tenant, setLoading } = useContext(ContextOperation);

  const navigate = useNavigate();

  const form = useForm<FormInputs>({
    defaultValues: {      
      formCode: props.formCode || undefined,
    },
  });

  const onSubmit = (data: FormInputs) => {
    DamagePriceService.get.formByCode(tenant, data.formCode).then((response) => {
      navigate('/operation/damages/list/add',{state: response});
    })
  }

  const forms = useMemo<AutoCompleteOption[]>(() => {
    return props.forms.map((form) => ({
      label: form,
      value: form
    }))
  }, [props.forms]);

    return(
        <Mui.Dialog 
            maxWidth="sm"
            fullWidth
            open={props.isOpen} 
            onClose={props.onClose}
        >
      <Mui.DialogTitle>
        <Mui.Grid container columnSpacing={1}>
          <Mui.Grid item xs="auto">
            <Mui.Typography variant="h5">
              {t("damageList.damageCreation.formSelection.title")}
            </Mui.Typography>
          </Mui.Grid>

          <Mui.Grid item xs="auto" marginLeft="auto">
            <Mui.IconButton onClick={props.onClose}>
              <MuiIcons.Close />
            </Mui.IconButton>
          </Mui.Grid>
        </Mui.Grid>
      </Mui.DialogTitle>

      <form onSubmit={form.handleSubmit(onSubmit)}>
        <Mui.DialogContent>
          <FormInput 
              name={nameof<FormInputs>("formCode")}
              type="select"
              options={forms}
              label={t("damageList.damageCreation.formSelection.formCode")}
              fullWidth
              formInstance={form}
          />
          
        </Mui.DialogContent>

        <Mui.DialogActions>
          <Mui.Button variant="outlined" onClick={props.onClose}>
            {t("damageList.damageCreation.formSelection.button.cancel")}
          </Mui.Button>

          <Mui.Button variant="contained" type="submit">
            {t("damageList.damageCreation.formSelection.button.proceed")}
          </Mui.Button>
        </Mui.DialogActions>
      </form>
    </Mui.Dialog>
    )
}
export default ChooseForm;